import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, ProseSection, EndCTA } from "../../components/PageParts";

export default function Deroulement() {
  const BC = [{ to: "/", label: "Accueil" }, { to: "/votre-seance", label: "Votre séance" }, { label: "Déroulement" }];
  return (
    <>
      <Seo
        title="Déroulement d'une séance d'hypnose"
        description="Comment se déroule concrètement une séance d'hypnose avec Valentine DL à Pantin ou en ligne ? Étapes, ambiance, durée, ce que vous ressentirez."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance/deroulement"
      />
      <PageHero breadcrumb={BC} eyebrow="Le format" title="Comment se déroule" italic="une séance d'hypnose ?" />
      <ProseSection>
        <p>
          Que la séance ait lieu au{" "}
          <Link to="/votre-seance/cabinet-pantin" className="text-[#B07A45] underline hover:text-sand-900">
            cabinet à Pantin
          </Link>{" "}
          ou{" "}
          <Link to="/votre-seance/en-ligne" className="text-[#B07A45] underline hover:text-sand-900">
            en visio
          </Link>
          , sa structure reste la même. Voici, étape par étape, ce à quoi vous pouvez vous attendre.
        </p>

        <h2 className="font-serif text-3xl text-sand-900">1. L'échange préalable</h2>
        <p>
          Nous commençons toujours par un temps de dialogue. Vous me parlez de ce qui vous amène,
          de ce que vous souhaiteriez explorer ou dénouer, et de votre contexte. Ce moment n'est
          pas anecdotique&nbsp;: c'est là que nous définissons ensemble un objectif clair pour la séance.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">2. L'induction hypnotique</h2>
        <p>
          Confortablement installé·e (allongé·e ou assis·e), vous êtes guidé·e par ma voix vers un
          état de <strong className="text-sand-900 font-medium">relaxation profonde</strong>. Ce n'est
          pas du sommeil&nbsp;: vous restez conscient·e à chaque instant, capable de bouger, parler,
          ouvrir les yeux si vous le souhaitez.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">3. Le travail proprement dit</h2>
        <p>
          Une fois l'état d'hypnose installé, je vous accompagne dans le travail défini ensemble.
          Chaque séance est unique&nbsp;: métaphores, visualisations, dialogues intérieurs, silences —
          j'adapte ce que je propose à ce que vit votre inconscient. L'approche mobilisée dépend
          de votre demande&nbsp;: plutôt{" "}
          <Link to="/hypnose/ericksonienne" className="text-[#B07A45] underline hover:text-sand-900">
            ericksonienne
          </Link>{" "}
          pour un objectif précis, plutôt{" "}
          <Link to="/hypnose/spirituelle" className="text-[#B07A45] underline hover:text-sand-900">
            spirituelle
          </Link>{" "}
          pour une exploration en profondeur.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">4. Le retour et l'intégration</h2>
        <p>
          Je vous ramène doucement à votre pleine conscience, puis nous prenons le temps d'échanger
          sur ce qui a été vécu. Ce temps d'intégration est essentiel pour ancrer les prises de conscience.
        </p>
        <p>
          Compter <strong className="text-sand-900 font-medium">1h à 1h15</strong> en hypnose ericksonienne,
          <strong className="text-sand-900 font-medium"> environ 2h</strong> en hypnose spirituelle.
          Les{" "}
          <Link to="/votre-seance/tarifs" className="text-[#B07A45] underline hover:text-sand-900">
            tarifs et modalités de règlement
          </Link>{" "}
          sont détaillés sur une page dédiée.
        </p>
      </ProseSection>
      <EndCTA testid="deroulement-end" />
    </>
  );
}
